export default __webpack_public_path__ + "static/media/project2.97ff7c03.png";